module.exports = __webpack_public_path__ + "static/media/regresar.066e9bb2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/SupervisorChat/regresar.svg
// module id = 1837
// module chunks = 0